<template lang="pug">
.tooltip(:id='id', :class='`tooltip--${this.position}`', :style='{ minWidth }')
    span {{ label }}
</template>
<script>
export default {
    name: 'TooltipComponent',
    props: {
        id: {
            type: String,
            default: () => `tooltip-${Math.ceil(Math.random() * 10000)}`,
        },
        label: {
            type: String,
            required: true,
        },
        position: {
            type: String,
            default: 'bottom',
        },
        minWidth: {
            type: String,
        },
    },
};
</script>

<style lang="scss">
.tooltip {
    transition: opacity 0.2s;
    position: absolute;
    font-size: 13px;
    opacity: 0;
    pointer-events: none;
    cursor: default;
    color: #ffffff;
    text-align: center;
    padding: 5px;
    border-radius: 5px;
    background: #5e5d5d;
    z-index: 10000 !important;
    min-width: 100px;
    word-break: break-word;
    font-family: Helvetica, Arial, sans-serif;
    max-width: 150px;
    &::after {
        content: '';
        border-width: 5px;
        border-style: solid;
        position: absolute;
    }
    &.tooltip--top {
        &::after {
            bottom: -10px;
            left: 10px;
            border-color: #5e5d5d transparent transparent transparent;
        }
    }
    &.tooltip--right {
        &::after {
            top: 5px;
            left: -10px;
            border-color: transparent #5e5d5d transparent transparent;
        }
    }
    &.tooltip--bottom {
        &::after {
            top: -10px;
            left: 10px;
            border-color: transparent transparent #5e5d5d transparent;
        }
    }
    &.tooltip--left {
        &::after {
            top: 5px;
            right: -10px;
            border-color: transparent transparent transparent #5e5d5d;
        }
    }
}
</style>
